class DoctorImageSlider {
  constructor(sliderElement) {
    this.slider = sliderElement;
    this.track = this.slider.querySelector('.slider-track');
    this.slides = Array.from(this.track.querySelectorAll('.wp-block-improntad-blocks-responsive-image'));
    this.prevButton = this.slider.querySelector('.slider-button-prev');
    this.nextButton = this.slider.querySelector('.slider-button-next');

    this.currentIndex = 0;
    this.autoAdvanceDelay = parseInt(this.slider.dataset.autoAdvanceDelay) || 5000;
    this.autoAdvanceTimer = null;
    this.isPaused = false;
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.init();
  }

  init() {
    if (this.slides.length === 0) {
      return;
    }

    this.slides[0].classList.add('is-active');

    if (this.slides.length > 1) {
      this.bindEvents();

      if (!this.prefersReducedMotion) {
        this.startAutoAdvance();
      }
    }
  }

  bindEvents() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.previous());
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.next());
    }

    this.slider.addEventListener('mouseenter', () => this.pause());
    this.slider.addEventListener('mouseleave', () => this.resume());
    this.slider.addEventListener('focusin', () => this.pause());
    this.slider.addEventListener('focusout', () => this.resume());

    this.slider.addEventListener('keydown', (e) => this.handleKeyboard(e));
  }

  handleKeyboard(e) {
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      this.previous();
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      this.next();
    }
  }

  goToSlide(index) {
    this.slides[this.currentIndex].classList.remove('is-active');

    this.currentIndex = index;

    if (this.currentIndex < 0) {
      this.currentIndex = this.slides.length - 1;
    } else if (this.currentIndex >= this.slides.length) {
      this.currentIndex = 0;
    }

    this.slides[this.currentIndex].classList.add('is-active');

    this.resetAutoAdvance();
  }

  previous() {
    this.goToSlide(this.currentIndex - 1);
  }

  next() {
    this.goToSlide(this.currentIndex + 1);
  }

  startAutoAdvance() {
    if (this.prefersReducedMotion || this.slides.length <= 1) {
      return;
    }

    this.autoAdvanceTimer = setTimeout(() => {
      if (!this.isPaused) {
        this.next();
      }
    }, this.autoAdvanceDelay);
  }

  resetAutoAdvance() {
    this.stopAutoAdvance();

    if (!this.isPaused && !this.prefersReducedMotion) {
      this.startAutoAdvance();
    }
  }

  stopAutoAdvance() {
    if (this.autoAdvanceTimer) {
      clearTimeout(this.autoAdvanceTimer);
      this.autoAdvanceTimer = null;
    }
  }

  pause() {
    this.isPaused = true;
    this.stopAutoAdvance();
  }

  resume() {
    this.isPaused = false;

    if (!this.prefersReducedMotion) {
      this.startAutoAdvance();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.doctor-profile-image-slider');

  sliders.forEach((slider) => {
    new DoctorImageSlider(slider);
  });

  const containers = document.querySelectorAll('.doctor-profile-image-container');

  const resizeObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      entry.target.style.setProperty('--image-container-height', `${entry.contentRect.height}px`);
    });
  });

  containers.forEach((container) => {
    resizeObserver.observe(container);
  });
});
